var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.get_url)?_c('div',[_c('k-video-player',{attrs:{"url":_vm.get_url,"load-player":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }